import PodoCore from '@/plugins/podolib';
import consola from 'consola';

import { Route } from 'vue-router';
import { StateStatus } from '@/plugins/podolib/services/analytics';
import { get } from 'lodash';

export default async (to: Route, from: Route, next: (path?: any) => void) => {
  const logger = consola.withScope('middleware');

  if (PodoCore.analytics!.status === StateStatus.Wait) {
    logger.log('⏳ Wait analytics service to be ready...');

    await new Promise((resolve) => {
      let _s = () => {
        clearTimeout(_timeout);

        PodoCore.bus!.off('analytics:loaded', _s);
        PodoCore.bus!.off('analytics:timeout', _s);

        resolve();
      };

      let _f = () => {
        PodoCore.bus!.emit('analytics:middleware-timeout');
        _s();
      };

      const _timeout = setTimeout(_f, 4000);

      PodoCore.bus!.on('analytics:loaded', _s);
      PodoCore.bus!.on('analytics:timeout', _s);
    });
  }

  // Default route variable
  let defaultRouteName;

  try {
    // Check if user authenticated ...
    const user = await PodoCore.cognito!.getUser();

    if ((user as any)?.challengeName) {
      if (to.name === 'auth-mfa' && (user as any).challengeName === 'SOFTWARE_TOKEN_MFA') {
        return await next();
      } else {
        throw new Error('Challenge not implemented');
      }
    }

    // If it's the first route ...
    if (from.name === null && !PodoCore.repository!.socket!.connected) {
      // Initiate connection with the cloud
      await PodoCore.repository!.socket!.connect();
    }

    // Lock to home to do welcome process
    const lockedByWelcome = !PodoCore.entities!.stations.storedEntity.list.length && PodoCore.doctor!.current?.hasKit;
    const lockedByDemo = PodoCore.helper!.isDemo || !PodoCore.entities!.stations.storedEntity.list.length;
    // Researchers
    const userSessionToken = PodoCore.cognito!.user.signInUserSession.accessToken.payload;
    const isResearchAccount = get(userSessionToken, 'cognito:groups')
      ? !!userSessionToken['cognito:groups'].find((x: string) => x === 'researchers')
      : false;

    // TODO : get rules from API
    // Update abilities
    PodoCore.acl!.updateAbilities([
      { action: 'route', subject: ['auth-sign-in'], inverted: true },
      { action: 'route', subject: ['auth-mfa'], inverted: true },
      { action: 'route', subject: ['auth-sign-up'], inverted: true },
      { action: 'route', subject: ['auth-confirm-sign-up'], inverted: true },
      { action: 'route', subject: ['auth-forgot-password'], inverted: true },
      { action: 'route', subject: ['auth-reset-password'], inverted: true },

      { action: 'route', subject: ['auth-create-doctor-profile'] },
      { action: 'route', subject: ['home'] },
      { action: 'route', subject: ['account'], inverted: lockedByWelcome },
      { action: 'route', subject: ['patients'], inverted: lockedByWelcome },
      { action: 'route', subject: ['patient'], inverted: lockedByWelcome },
      { action: 'route', subject: ['patient-evolution'], inverted: lockedByWelcome },
      { action: 'route', subject: ['patient-comparison'], inverted: lockedByWelcome },
      { action: 'route', subject: ['patient-result'], inverted: lockedByWelcome },
      { action: 'route', subject: ['analysis'], inverted: lockedByDemo },
      { action: 'route', subject: ['equipments'], inverted: lockedByDemo },
      { action: 'route', subject: ['settings'], inverted: lockedByWelcome },
      { action: 'route', subject: ['subscription'], inverted: lockedByWelcome },
      { action: 'route', subject: ['about'], inverted: lockedByWelcome },
      { action: 'route', subject: ['not-found'] },
      { action: 'route', subject: ['not-authorized'] },

      // Components
      { action: 'read', subject: ['excel-download'], inverted: !isResearchAccount },
      { action: 'read', subject: ['research-analysis'], inverted: !isResearchAccount },
    ]);

    // Overwrite default route
    defaultRouteName = 'home';
  } catch (e) {
    // Overwrite default route
    defaultRouteName = 'auth-sign-in';

    if (e.message === 'NotDoctorProfile') {
      defaultRouteName = 'auth-create-doctor-profile';

      PodoCore.bus!.emitDebug('app:ready');
    }

    if (to.name === defaultRouteName && (e === 'No current user' || e === 'not authenticated')) {
      // Reset abilities
      PodoCore.acl!.resetAbilities();

      PodoCore.bus!.emitDebug('app:ready');
    }

    // TODO : add sentry catcher
  }

  // Check if access to this route allowed
  const accessAllowed = PodoCore.acl!.abilities.can('route', to.name!);

  logger.log('🦦 Watchotter', accessAllowed ? 'allow' : 'deny', `access to "${to.name}"`);

  if (!accessAllowed) logger.log(`Go to default route "${defaultRouteName}"`);

  // If access allowed, continue...
  if (accessAllowed) await next();
  // ...else, return to the default route
  else {
    // Analytics
    /*PodoCore.analytics!.actions.trackSuccess('ACL AccessDenied', {
      from: from.name,
      to: to.name,
      redirect: defaultRouteName
    });*/
    await next({
      name: defaultRouteName, // 'not-authorized',
      params: {
        defaultRouteName,
      },
    });
  }
};
